import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=c278c0d2&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=c278c0d2&prod&scoped=true&lang=css"
import style1 from "./Spinner.vue?vue&type=style&index=1&id=c278c0d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c278c0d2",
  null
  
)

export default component.exports